import { render, staticRenderFns } from "./MainStaff.vue?vue&type=template&id=6e57dabc"
import script from "./MainStaff.vue?vue&type=script&lang=js"
export * from "./MainStaff.vue?vue&type=script&lang=js"
import style0 from "./MainStaff.vue?vue&type=style&index=0&id=6e57dabc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports